import axios from 'axios'

export const HTTP = axios.create({
  baseURL: `http://yalaagame.com/MatrixGamesAPI/APIs/`
})
